export default __webpack_public_path__ + "static/media/train02.078da1e8.jpg";